export function setCardsUser(data) {
  const cardUser = {
    ...this.state.cardUser,
    cards: data,
  };
  this.setState({ cardUser });
}
